import { PILLARS } from "../data/content";
import { Reveal, SectionHeading } from "./Reveal";

export const WhyUs = () => (
  <section id="perche-noi" data-testid="why-us-section" className="relative py-24 sm:py-32 bg-[#231e16] border-y border-amber-500/10">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading
        eyebrow="Perché Sceglierci"
        title="L'Affidabilità di un Service, l'Occhio di uno Scenografo"
        testId="why-us-title"
      />

      <div className="mt-14 grid gap-px bg-amber-500/10 border border-amber-500/10 sm:grid-cols-2 lg:grid-cols-4">
        {PILLARS.map((p, i) => (
          <Reveal key={p.number} delay={i * 0.1} className="h-full">
            <div
              data-testid={`pillar-${p.number}`}
              className="h-full bg-[#181410] p-8 hover:bg-[#2d261b] transition-colors duration-300"
            >
              <span className="text-4xl font-serif italic text-amber-400/70">{p.number}</span>
              <h3 className="mt-5 text-lg sm:text-xl font-sans font-semibold tracking-wide text-[#FBF9F5]">
                {p.title}
              </h3>
              <p className="mt-3 text-sm text-stone-400 leading-relaxed">{p.description}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
